// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { localize } from 'i18n-calypso'

// Internal Dependencies:
import SearchResult from './SearchResult'
import { loop } from 'church-theme-library/utilities/objects'

class SearchResultsOther extends React.Component {
	renderResult = ( key, item, mostRelevant = false ) => {
		return (
			<SearchResult key={ item.id } searchResult={ item } mostRelevant={ mostRelevant } />
		)
	}

	render() {
		const { translate, searchResults, isMobile } = this.props

		const types = {
			pages: {
				type: 'page',
				title: translate( 'Pages' ),
			},
			ministries: {
				type: 'ministry',
				title: translate( 'Ministries' ),
			},
			sermons: {
				type: 'sermon',
				title: translate( 'Sermons' ),
			},
			events: {
				type: 'event',
				title: translate( 'Events' ),
			},
			resources: {
				type: 'resource',
				title: translate( 'Resources' ),
			},
			news: {
				type: 'post',
				title: translate( 'News' ),
			},
			galleries: {
				type: 'gallery',
				title: translate( 'Galleries' ),
			}
		}

		let markup = loop( types, ( key, item ) => {
			let itemsMarkup = loop( searchResults[ key ], this.renderResult )

			if ( ! itemsMarkup ) {
				return null
			}

			return (
				<div className="-other-results-wrap" key={ key }>
					<div className="-other-results">
						<h3>{ item.title }</h3>

						{ itemsMarkup }
					</div>
				</div>
			)
		} )

		if ( searchResults.most_relevant ) {
			markup.unshift(
				<div className="-other-results-wrap -most-relevant" key="most_relevant">
					<div className="-other-results">
						<h3>{ translate( 'Top result' ) }</h3>

						{ this.renderResult( 'most_relevant', searchResults.most_relevant, true ) }
					</div>
				</div>
			)
		}

		markup = markup.filter( Boolean )

		if ( isMobile ) {
			return (
				<div className="posts-section-b-mobile">
					<div className="-inner">
						{ markup }
					</div>
				</div>
			)
		} else {
			return markup
		}
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		searchResults: state.search.searchResults,
		isMobile: state.site.isMobile
	}
}

export default localize(
	connect( mapStateToProps )( SearchResultsOther )
)
